import styled from 'styled-components';

import { Cta } from 'core/components/Cta/Cta.style';
import { Icon } from 'core/components/Icon/Icon.style';

import { Ul as UlBase } from '../../Header.style';

export const Wrapper = styled.div`
	display: inline-flex;
	margin-left: auto;
	align-items: center;
	padding-right: 25px;
`;

export const BtnWrapper = styled.div`
	position: relative;
	display: inline-block;

	& + & {
		margin-left: 20px;
	}

	/* Adjust the icon position of the btn */
	> ${/* sc-selector */ Cta} {
		&:hover,
		&:focus {
			button {
				border-radius: 48px;
				background-color: ${({ theme }) =>
					theme.global.page.authenticatedHeader.notifications.iaHoverColor};
			}
		}

		${/* sc-selector */ Icon}:first-of-type {
			margin: 0 8px 0 0;
		}

		${/* sc-selector */ Icon}:last-of-type {
			margin: 0 0 0 8px;
		}
	}
`;

export const Ul = styled(UlBase as any)`
	width: 200px;

	&& > li {
		a {
			justify-content: flex-end;
			text-align: start;
			padding: 12px 24px;

			i {
				margin-right: 20px;
				color: ${({ theme }) => theme.global.ctas.primary.base.color};

				/* Prevent the icon shrink */
				flex-shrink: 0;
				opacity: 0.44;
			}
		}

		${Cta} {
			display: block;

			a,
			span {
				margin: 0;
				width: 100%;
			}
		}

		a:hover i {
			opacity: 1;
		}
	}
`;
